/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddUserToSpaceResult } from '../models/add-user-to-space-result';
import { apiSpacesGet } from '../fn/spaces/api-spaces-get';
import { ApiSpacesGet$Params } from '../fn/spaces/api-spaces-get';
import { apiSpacesIdDelete } from '../fn/spaces/api-spaces-id-delete';
import { ApiSpacesIdDelete$Params } from '../fn/spaces/api-spaces-id-delete';
import { apiSpacesIdGet } from '../fn/spaces/api-spaces-id-get';
import { ApiSpacesIdGet$Params } from '../fn/spaces/api-spaces-id-get';
import { apiSpacesIdPut } from '../fn/spaces/api-spaces-id-put';
import { ApiSpacesIdPut$Params } from '../fn/spaces/api-spaces-id-put';
import { apiSpacesIdUsersPost } from '../fn/spaces/api-spaces-id-users-post';
import { ApiSpacesIdUsersPost$Params } from '../fn/spaces/api-spaces-id-users-post';
import { apiSpacesIdUsersUserIdDelete } from '../fn/spaces/api-spaces-id-users-user-id-delete';
import { ApiSpacesIdUsersUserIdDelete$Params } from '../fn/spaces/api-spaces-id-users-user-id-delete';
import { apiSpacesPost } from '../fn/spaces/api-spaces-post';
import { ApiSpacesPost$Params } from '../fn/spaces/api-spaces-post';
import { CreateSpaceResult } from '../models/create-space-result';
import { SpaceDto } from '../models/space-dto';
import { UpdateSpaceResult } from '../models/update-space-result';


/**
 * User spaces — users can invite each other with different roles
 */
@Injectable({ providedIn: 'root' })
export class SpacesService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSpacesGet()` */
  static readonly ApiSpacesGetPath = '/api/Spaces';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSpacesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSpacesGet$Response(params?: ApiSpacesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SpaceDto>>> {
    const obs = apiSpacesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSpacesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSpacesGet(params?: ApiSpacesGet$Params, context?: HttpContext): Observable<Array<SpaceDto>> {
    const resp = this.apiSpacesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SpaceDto>>): Array<SpaceDto> => r.body)
    );
  }

  /** Path part for operation `apiSpacesPost()` */
  static readonly ApiSpacesPostPath = '/api/Spaces';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSpacesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSpacesPost$Response(params?: ApiSpacesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSpaceResult>> {
    const obs = apiSpacesPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSpacesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSpacesPost(params?: ApiSpacesPost$Params, context?: HttpContext): Observable<CreateSpaceResult> {
    const resp = this.apiSpacesPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateSpaceResult>): CreateSpaceResult => r.body)
    );
  }

  /** Path part for operation `apiSpacesIdGet()` */
  static readonly ApiSpacesIdGetPath = '/api/Spaces/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSpacesIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSpacesIdGet$Response(params: ApiSpacesIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SpaceDto>> {
    const obs = apiSpacesIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSpacesIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSpacesIdGet(params: ApiSpacesIdGet$Params, context?: HttpContext): Observable<SpaceDto> {
    const resp = this.apiSpacesIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SpaceDto>): SpaceDto => r.body)
    );
  }

  /** Path part for operation `apiSpacesIdPut()` */
  static readonly ApiSpacesIdPutPath = '/api/Spaces/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSpacesIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSpacesIdPut$Response(params: ApiSpacesIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSpaceResult>> {
    const obs = apiSpacesIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSpacesIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSpacesIdPut(params: ApiSpacesIdPut$Params, context?: HttpContext): Observable<UpdateSpaceResult> {
    const resp = this.apiSpacesIdPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UpdateSpaceResult>): UpdateSpaceResult => r.body)
    );
  }

  /** Path part for operation `apiSpacesIdDelete()` */
  static readonly ApiSpacesIdDeletePath = '/api/Spaces/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSpacesIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSpacesIdDelete$Response(params: ApiSpacesIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiSpacesIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSpacesIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSpacesIdDelete(params: ApiSpacesIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiSpacesIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSpacesIdUsersPost()` */
  static readonly ApiSpacesIdUsersPostPath = '/api/Spaces/{id}/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSpacesIdUsersPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSpacesIdUsersPost$Response(params: ApiSpacesIdUsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddUserToSpaceResult>> {
    const obs = apiSpacesIdUsersPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSpacesIdUsersPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSpacesIdUsersPost(params: ApiSpacesIdUsersPost$Params, context?: HttpContext): Observable<AddUserToSpaceResult> {
    const resp = this.apiSpacesIdUsersPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AddUserToSpaceResult>): AddUserToSpaceResult => r.body)
    );
  }

  /** Path part for operation `apiSpacesIdUsersUserIdDelete()` */
  static readonly ApiSpacesIdUsersUserIdDeletePath = '/api/Spaces/{id}/users/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSpacesIdUsersUserIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSpacesIdUsersUserIdDelete$Response(params: ApiSpacesIdUsersUserIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiSpacesIdUsersUserIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSpacesIdUsersUserIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSpacesIdUsersUserIdDelete(params: ApiSpacesIdUsersUserIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiSpacesIdUsersUserIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
